<template>
	<div>
		  <Breadcrumbs main="Vendors" title="Add Raw Material" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
							   	</div>
							</div>
 
							<form  @submit.prevent="addRawMaterial" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Raw Material<span class="text-danger">*</span></label>
												<select class="form-select" v-model="raw_material_id" @change="fetchRawMaterials()">
													<option value="">Choose Material</option>
													<option :value="material.id" v-for="material in rawMaterails" :key="material.id">{{material.raw_material_name}}</option>
												</select>
											</div>
										</div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Stock<span class="text-danger">*</span></label>
												<input class="form-control" type="number" placeholder="" v-model="product_stock"/>
													
											</div>
										</div>
										
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script>
	export default {
		name: "Add Campaign Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

				button_title: "Save",

				rawMaterails:{},

				
				raw_material_id:"",
				product_stock: "",
				

				// delete: false,
				// active_page_url: null,
			};
		},
		created() {
			// this.addRow();
			this.fetchRawMaterials();

		},
		
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchRawMaterials() {
				this.getToken();
				this.$axios
					.get("/staffs/getRawMaterials", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.rawMaterails = responseData.data;
						console.log(this.types);
					})
					.catch((err) => console.log(err));
			},

			addRawMaterial() 
			{
				this.getToken();
				let formData = new FormData();
                formData.append("vendor_id", this.$route.params.id);
                formData.append("raw_material_id", this.raw_material_id);
                formData.append("stock", this.product_stock);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url = "/staffs/assignRawMaterial";
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.fetchRawMaterials
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			// addRow() {
			// 	this.inputs.push({
			// 		name: "",
			// 		phone: "",
			// 		email: ""
			// 	});
			// },

			// deleteRow(index) {
			// 	this.inputs.splice(index, 1);
			// },

			addRow() {
              	this.inputs.push({ value: null });
			},

			deleteRow(index) {
				this.inputs.splice(index, 1);
				this.campaign_images.splice(index, 1);
			}, 

			campaign_setFile(e, index) {
				this.campaign_images.push(e.target.files[0]);
				this.inputs[index].image = e.target.files[0];
				this.inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
			},
				
			clearForm() {
				this.edit = false;
				this.errors = {};
			},

		},
	};

</script>